import { motion } from "framer-motion";
import { useState } from "react";

const LandingFooter = () => {
  const [email, setEmail] = useState("");

  return (
    <section
      id="get-started"
      className="py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-[#00ff9d]/6 rounded-full blur-[90px]" />
        <div className="absolute bottom-1/4 left-1/3 w-96 h-96 bg-emerald-400/5 rounded-full blur-[120px]" />
      </div>

      <div className="max-w-7xl mx-auto relative">
        <div className="absolute inset-0 bg-[radial-gradient(rgba(35,35,35,0.55)_1px,transparent_1px)] bg-[length:20px_20px] opacity-20" />

        <div className="relative bg-black/30 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-sm">
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white">
              Join the Portal today.
            </h2>
            <p className="text-xl text-white/70 max-w-xl mx-auto">
              Claim your amPassport to start earning presence.
            </p>
          </motion.div>

          <motion.div
            className="mb-16 max-w-xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <div className="flex flex-col md:flex-row items-stretch gap-4">
              <div className="flex-1 relative">
                <input
                  type="text"
                  placeholder="Enter ArNS or wallet address"
                  className="w-full bg-black/40 border border-[#00ff9d]/30 text-white px-6 py-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#00ff9d]/50 transition-all"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {email && (
                  <div className="absolute inset-0 bg-[#00ff9d]/5 rounded-xl blur-sm -z-10" />
                )}
              </div>
              <button className="bg-[#00ff9d] text-[#040606] font-bold px-8 py-4 rounded-xl hover:bg-[#00e68d] transition-all shadow-lg shadow-[#00ff9d]/20 hover:shadow-[#00ff9d]/30 hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center">
                Get Started
                <svg
                  className="ml-2 w-5 h-5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <p className="text-white/50 text-sm mt-3 text-center md:text-left">
              No wallet? No problem. Sign up with email to get started.
            </p>
          </motion.div>

          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <p className="text-xl text-white/70 mb-6">Or join the community</p>
            <div className="flex justify-center gap-4">
              <motion.a
                href="#"
                className="p-4 rounded-full border border-[#00ff9d]/30 bg-black/30 hover:bg-[#00ff9d]/10 transition-all group"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="group-hover:text-[#00ff9d] transition-colors text-[#00ff9d]/80"
                >
                  <path
                    d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932L18.901 1.153ZM17.61 20.644h2.039L6.486 3.24H4.298L17.61 20.644Z"
                    fill="currentColor"
                  />
                </svg>
              </motion.a>
              <motion.a
                href="#"
                className="p-4 rounded-full border border-[#00ff9d]/30 bg-black/30 hover:bg-[#00ff9d]/10 transition-all group"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <img
                  src="https://res.cloudinary.com/dmw1bwmpr/image/upload/v1744910864/Discord_Logo_dreva5.svg"
                  alt="Discord"
                  className="w-6 h-6"
                />
              </motion.a>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="mt-12 border-t border-white/10 pt-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center gap-2 mb-6 md:mb-0">
              <img
                src="https://res.cloudinary.com/dmw1bwmpr/image/upload/v1745139360/Main_Icon_qxmxdv.svg"
                alt="amPortal"
                className="w-10 h-10"
              />
              <span className="text-white font-bold text-xl">amPortal</span>
            </div>

            <div className="flex flex-wrap justify-center gap-6">
              <a href="#" className="text-[#00ff9d] hover:text-[#00ff9d]/80 transition-colors">
                Docs
              </a>
              <a href="#" className="text-[#00ff9d] hover:text-[#00ff9d]/80 transition-colors">
                Terms
              </a>
              <a href="#" className="text-[#00ff9d] hover:text-[#00ff9d]/80 transition-colors">
                Privacy
              </a>
              <a href="#" className="text-[#00ff9d] hover:text-[#00ff9d]/80 transition-colors">
                Blog
              </a>
              <a href="#" className="text-[#00ff9d] hover:text-[#00ff9d]/80 transition-colors">
                Contact
              </a>
            </div>
          </div>

          <div className="mt-6 text-center md:text-right text-sm text-white/40">
            <p>© {new Date().getFullYear()} amPortal. All rights reserved.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default LandingFooter;
